import '/app/brewery-packages/content/content-editor-plugin-paragraph/src/Paragraph.css-raw';
export default {
  "paragraph": "about-us-b998e096-paragraph-WaWZGW"
};